import { iconVariants, type IconComponent } from '@fountain/ripple/icon';
import React from 'react';

import { cssVar, rippleNeutral } from 'theme';

export interface MenuIconSlotProps {
  icon: IconComponent;
  kept?: boolean;
  size?: 'sm' | 'md';
  isDisabled?: boolean;
}

export const MenuIconSlot = ({
  icon: Glyph,
  kept = false,
  size = 'md',
  isDisabled = false,
}: MenuIconSlotProps) => {
  const color = isDisabled ? 'neutral-300' : 'neutral-400';

  return (
    <span
      data-slot="menu-icon-slot"
      aria-hidden="true"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 20,
        height: 20,
        color: cssVar(color, rippleNeutral[color]),
      }}
    >
      <Glyph
        aria-hidden="true"
        className={iconVariants({ size: kept ? 'sm' : size })}
      />
    </span>
  );
};
